<template>
  <div class="ruleContent">
    <p class="title">服务协议</p>
    <p>
      您通过网络页面点击确认或同意接受《服务协议》（以下简称“本协议”），即视为您与云南祐祉商务信息咨询有限公司已达成合意并接受本协议约定的内容。在您确认接受本协议前，请您务必审慎阅读并充分理解本协议各条款的内容，尤其是免除或限制责任的条款、法律适用与管辖条款。免除或限制责任的条款将以粗体标识，您应重点阅读。</p>
    <p> </p>
    <p>如果您对协议内容有任何的疑问，可联系我们进行咨询。在您确认接受本协议全部条款之前，请勿进行下一步操作。</p>
    <p> </p>
    <p>一、服务提示</p>
    <p>1.请您在投保前，认真评估保障需求，根据实际需要合理选择金融产品。如果您对金融产品的选择有任何的疑问，您可通过平台微信公众号、客服电话、进行咨询，云南祐祉商务信息咨询有限公司学驾易平台将为您提供专业的咨询服务。</p>
    <p> </p>
    <p>2.请您在购买前，务必认真阅读保险条款和投保须知等内容，了解保险责任、责任免除、等重要内容。</p>
    <p> </p>
    <p>3.请您在购买前，认真阅读告知书并履行如实告知义务。若您未履行如实告知义务，将有权解除保险合同，并对保险合同解除前发生的保险事故不承担保险责任。</p>
    <p> </p>
    <p>4.您通过本服务从事的交易可能面临以下风险，这些风险需要您自行承担：</p>
    <p>(1)监管风险：法律法规､监管政策和规定发生变化，导致您的交易目的无法实现，您由此可能遭受损失；</p>
    <p>(2)违约风险：因无力或其他原因不能履约，您由此可能遭受损失；</p>
    <p>(3)交易风险：您通过本服务所购买的保险产品最终没有达成交易，您无法获得保险产品和服务；</p>
    <p>(4)过错风险：因您的过错导致的任何损失，包括但不限于决策失误、不诚信行为、操作不当、遗忘或泄漏密码、非本人操作或委托不当等。</p>
    <p> </p>
    <p>5.您在云南祐祉商务信息咨询有限公司旗下学驾易平台提供或填写的信息（包括但不限于注册信息、投保信息等）应是真实、准确、合法有效的，如有变化，您应及时修改并重新提交。若因您提交的信息不真实、不准确、不合法或失效，您应承担由此引起的不利后果。</p>
    <p> </p>
    <p>6.您同意并授权云南祐祉商务信息咨询有限公司旗下学驾易平台开通客户资金专用账户通过微信支付等第三方支付机构收取保费并按照与的约定将保费解付至。</p>
    <p>二、协议的范围与性质</p>
    <p> </p>
    <p>1.本协议是您与学驾易平台之间订立的委托协议，而保险合同的订立和履行由您和共同合意完成。学驾易平台基于您的合法权益，为您和之间订立保险合同提供信息、科技服务。</p>
    <p> </p>
    <p>2.本协议是您与云南祐祉商务信息咨询有限公司旗下学驾易平台之间关于学驾易平台服务所订立的协议。学驾易平台相关服务可能存在的运营关联单位同样在本协议中享有学驾易平台的权益；</p>
    <p> </p>
    <p>3.您在使用学驾易平台某一项服务时，该服务可能会另有单独的协议、业务规则等。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守；</p>
    <p>4.您在学驾易平台上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。学驾易平台和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
    <p> </p>
    <p>三、协议的生效、变更与转让</p>
    <p> </p>
    <p>1.您通过公众号页面点击确认或同意接受本协议，或使用学驾易平台的服务即视为您已阅读本协议并接受本协议的约束，本协议即刻生效；</p>
    <p> </p>
    <p>2.鉴于互联网服务的特殊性，您同意并授权学驾易平台根据国家法律法规和政策的变化及时修订本协议。修订后的协议将通过原有展示方式向您公布，如您对本协议的修订有任何的疑问，可以联系学驾易平台进行咨询；</p>
    <p> </p>
    <p>3.本协议条款修改或变更后，如果您继续使用学驾易平台提供的软件或服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用学驾易平台提供的软件或服务；</p>
    <p> </p>
    <p>4.除非您与学驾易平台另有约定外，您同意本服务仅为您本人使用，您依本协议条款所取得的权利不可转让。</p>
    <p> </p>
    <p>四、个人信息保护</p>
    <p> </p>
    <p>
      保护您的个人信息是学驾易平台的一项核心原则。学驾易平台将按照本协议及《隐私政策》的规定收集、使用、储存、分享您的个人信息。本协议内容同时包括《隐私政策》，即为本协议不可分割的组成部分，您对本协议的接受，即视为您对《隐私政策》的接受。</p>
    <p> </p>
    <p> 五、行为规范</p>
    <p> </p>
    <p>1.您在使用本服务时须遵守法律法规，不得利用本服务从事洗钱、窃取商业秘密、窃取个人信息等违法违规活动；</p>
    <p> </p>
    <p>2.不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</p>
    <p> </p>
    <p>3.您不得利用学驾易平台提供的服务从事任何牟利或经营活动；</p>
    <p> </p>
    <p>4.您不得使用未经学驾易平台授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响；</p>
    <p> </p>
    <p>5.您违反本条约定，导致学驾易平台或第三方损害的，您应当独立承担一切责任，包括但不限于：刑事责任、行政责任和民事责任。</p>
    <p> </p>
    <p>六、免责事由</p>
    <p> </p>
    <p>
      1.您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，学驾易平台将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失学驾易平台在法律允许的范围内免责；</p>
    <p> </p>
    <p>2.您同意下列情形已超出学驾易平台控制与合理预见，若因此给您造成了损失，学驾易平台可以免责：　　</p>
    <p>(1)您受到病毒、木马或其他恶意程序、黑客攻击的破坏；　　</p>
    <p>(2)您的手机、电脑软件、系统、硬件和通信线路出现故障；　</p>
    <p>(3)您通过非鼎和保险平台授权的方式使用本服务；</p>
    <p>(4)您未点击和阅读保险条款、投保须知等内容；</p>
    <p>(5)学驾易平台平台页面展示和设计原因给您造成损失；</p>
    <p>(6)学驾易平台平台系统原因导致您未成功投保、续保或支付保费；</p>
    <p>(7)学驾易平台平台系统不稳定或故障、通讯故障、银行原因、第三方服务瑕疵。</p>
    <p> </p>
    <p>3.除上述免责情形外，非因鼎和保险平台故意或重大过失给您造成损失的，学驾易平台也可以免责。</p>
    <p> </p>
    <p>七、服务的变更、中断、终止</p>
    <p> </p>
    <p>1.学驾易平台可能会对服务内容进行变更，也可能会中断、中止或终止服务；</p>
    <p> </p>
    <p>2.您理解并同意，在学驾易平台发生合并、分立、收购、资产转让时，学驾易平台可向第三方转让本服务下相关资产学驾易平台也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行；</p>
    <p> </p>
    <p>3.如发生下列任何一种情形，学驾易平台有权不经通知而中断或终止向您提供的服务：</p>
    <p>（1）您提供的个人资料不真实、不准确、不合法或失效；</p>
    <p>（2）您违反相关法律法规或本协议的约定；　　</p>
    <p>（3）按照法律规定或主管部门的要求。　</p>
    <p>　</p>
    <p>八、法律适用与管辖</p>
    <p> </p>
    <p>1.本协议的订立、效力、解释、履行及争议的解决均适用中华人民共和国法律。因本协议引起的或与本协议有关的任何争议，应首先通过协商方式解决。协商不成的，应将争议提交至云南祐祉商务信息咨询有限公司地址人民法院通过诉讼方式解决。</p>
    <p> </p>
    <p>2.本协议名称、条款的标题仅为查阅方便而设置，不应构成对本协议的任何解释，不对标题之下的内容及范围作任何限定。</p>
    <p> </p>

  </div>
</template>

<script>
export default {
  name: "fexy"
}
</script>

<style lang="scss" scoped>
.ruleContent {
  padding: 9px;
  background: #fff;
  min-height: 100%;
  font-size: 14px;
  color: #0C0C0C;
  line-height: 25px;
  //width: 100%;
  max-height: 500px;
  overflow: auto;
  margin: 0 auto;
  .title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// fwxy.vue?38320b6c